import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const TransferCompleteOverride = buildFacetDesignOverride()
  .override({ hint: 'richtext', readonly: true }, { _component: () => Richtext, _customProps: { align: 'start' } }, overrideReadOnly);
